<template>
    <v-container>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("fleet_dashboard")}}</h4>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4">
                <DashboardSheet
                    icon="mdi-truck-check"
                    :title="$t('ready_vehicles')"
                    icon-color="success"
                    value="215"/>
            </v-col>
            <v-col cols="12" md="4">
                <DashboardSheet
                    icon="mdi-truck"
                    :title="$t('idle_vehicles')"
                    icon-color="warning"
                    value="3"/>
            </v-col>
            <v-col cols="12" md="4">
                <DashboardSheet
                    icon="mdi-truck-alert"
                    :title="$t('unavailable_vehicles')"
                    icon-color="error"
                    value="23"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet outlined rounded="lg" class="pa-4" height="200">
                    <v-simple-table
                        dense>
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Ready</th>
                                <th>Idle</th>
                                <th>Unavailabe</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Truck Mixers</td>
                                <td>
                                    <div class="d-flex align-center">
                                        <v-icon left color="success">mdi-truck-check-outline</v-icon>
                                        <span class="font-weight-bold">70</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex align-center">
                                        <v-icon left color="warning">mdi-truck-outline</v-icon>
                                        <span class="font-weight-bold">2</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex align-center">
                                        <v-icon left color="error">mdi-truck-alert-outline</v-icon>
                                        <span class="font-weight-bold">4</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Concrete Pumps</td>
                                <td>
                                    <div class="d-flex align-center">
                                        <v-icon left color="success">mdi-truck-check-outline</v-icon>
                                        <span class="font-weight-bold">8</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex align-center">
                                        <v-icon left color="warning">mdi-truck-outline</v-icon>
                                        <span class="font-weight-bold">2</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex align-center">
                                        <v-icon left color="error">mdi-truck-alert-outline</v-icon>
                                        <span class="font-weight-bold">1</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Dump Trucks</td>
                                <td>
                                    <div class="d-flex align-center">
                                        <v-icon left color="success">mdi-truck-check-outline</v-icon>
                                        <span class="font-weight-bold">25</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex align-center">
                                        <v-icon left color="warning">mdi-truck-outline</v-icon>
                                        <span class="font-weight-bold">3</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex align-center">
                                        <v-icon left color="error">mdi-truck-alert-outline</v-icon>
                                        <span class="font-weight-bold">0</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Cement Silos</td>
                                <td>
                                    <div class="d-flex align-center">
                                        <v-icon left color="success">mdi-truck-check-outline</v-icon>
                                        <span class="font-weight-bold">21</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex align-center">
                                        <v-icon left color="warning">mdi-truck-outline</v-icon>
                                        <span class="font-weight-bold">1</span>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex align-center">
                                        <v-icon left color="error">mdi-truck-alert-outline</v-icon>
                                        <span class="font-weight-bold">2</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-sheet>
            </v-col>
            <v-col cols="12" md="6">
                <v-sheet class="d-flex pa-4 align-center" outlined rounded="lg" height="200">
                    <div class="me-4">
                        <v-progress-circular value="80" size="100" width="15" color="success"/>
                    </div>
                    <div>
                        <div class="font-weight-bold">Readiness</div>
                        <div class="text-h2">83%</div>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import DashboardSheet from '../../components/dashboard/DashboardSheet.vue';
export default {
    components: {
        DashboardSheet
    }
}
</script>

<style>

</style>